import { leaveBreadcrumb } from 'cfa-react-logging';
import authClient from '../authClient';
import ooeConstants from '../constants';
import { handleFetchFail, parseAsJson, throwIfNotOk } from '../util/httpUtils';
import { EulaMessage, eulaMessageTextSchema } from './schemas';

export const getEulaAcknowledgement = async (): Promise<object> => {
  const baseUrl = ooeConstants.URL.PROFILE;
  const url = `${baseUrl}/messagesAcknowledgements/1.0/${ooeConstants.EULA}/acknowledgement`;
  const method = 'GET';

  const apiKey = await authClient.getOrRenewAccessToken();
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `JWTBearer ${apiKey}`,
  };
  const response = await fetch(url, { method, headers }).catch(handleFetchFail);
  return parseAsJson(response);
};

export const getEulaMessageText = async (): Promise<EulaMessage> => {
  const baseUrl = ooeConstants.URL.PROFILE;
  const url = `${baseUrl}/messagesAcknowledgements/1.0/${ooeConstants.EULA}`;
  const method = 'GET';

  const apiKey = await authClient.getOrRenewAccessToken();
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `JWTBearer ${apiKey}`,
  };
  const response = await fetch(url, { method, headers }).catch(handleFetchFail);
  return eulaMessageTextSchema.parse(await parseAsJson(response));
};

export const addUserToEulaMessageAcknowledgement = async (): Promise<void> => {
  const baseUrl = ooeConstants.URL.PROFILE;
  const url = `${baseUrl}/messagesAcknowledgements/1.0/${ooeConstants.EULA}/acknowledgement`;
  const method = 'POST';
  const bugsnag = {
    breadcrumb: `Add User To EULA Message Acknowledgement`,
    errorClass: ooeConstants.BUGSNAG_ERRORCLASS_PROFILE,
    context: 'Add User To EULA Message Acknowledgement',
  };

  leaveBreadcrumb(bugsnag.breadcrumb, {
    url,
    method,
    context: bugsnag.context,
  });

  const apiKey = await authClient.getOrRenewAccessToken();
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `JWTBearer ${apiKey}`,
  };
  const response = await fetch(url, { method, headers }).catch(handleFetchFail);
  await throwIfNotOk(response);
};
